<template>
  <!-- 试卷管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['questionBank:testPaper:list']">
            <div class="title">
                <span class="name">{{ testPaperTextConfig.title }}</span>
                <el-button v-hasPermi="['questionBank:testPaper:add']" type="primary"
                           @click="editDialogVisible = true, row = null">
                    {{ testPaperTextConfig.add }}
                </el-button>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-input v-model="form.name" clearable :placeholder="searchTextConfig.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="form.status" clearable :placeholder="searchTextConfig.status">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                    <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                      element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium"
                      :height="height" style="width:100%">
                <el-table-column prop="name" :label="tableTextConfig.name"
                                 :min-width="flexColumnWidth('name',4,tableData)" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <a v-if="paperInfoPermissions"
                           @click="$router.push({name:'testPaperPreview',query:{id:scope.row.id,name:scope.row.name}})">
                            {{ scope.row.name }}
                        </a>
                        <span v-else>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="question_num" :label="tableTextConfig.questionNum" min-width="50">
                    <template slot-scope="scope">
                        <el-tooltip placement="right">
                            <div slot="content" style="line-height:22px"><span
                                    v-for="(e,j) in scope.row.metas.question_overview"
                                    :key="j">{{ e.label }}：{{ e.num }}<br/></span></div>
                            <el-button type="text">{{ scope.row.question_num }}</el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="total_score" :label="tableTextConfig.totalScore"
                                 min-width="50"></el-table-column>
                <el-table-column :label="tableTextConfig.updatedAt" min-width="150px">
                    <template slot-scope="scope">
                        <p>{{ scope.row.updated_by_username }}</p>
                        <p class="updateDate">{{ scope.row.updated_at | formatTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.status" min-width="80px">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status==0?'info':''">
                            {{ scope.row.status == 0 ? tableTextConfig.use.false : tableTextConfig.use.true }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" :label="tableTextConfig.operate" min-width="236px">
                    <template slot-scope="scope">
                        <el-button plain v-hasPermi="['questionBank:testPaper:add']" size="mini" type="primary"
                                   @click="copy(scope.row)">{{ buttonTextConfig.copy.name }}
                        </el-button>
                        <el-button plain v-hasPermi="['questionBank:testPaper:update']" size="mini" type="primary"
                                   @click="$router.push({name:'testPaperEdit',query:{id:scope.row.id,name:scope.row.name}})"
                                   :disabled="scope.row.status == 1">{{ buttonTextConfig.edit.name }}
                        </el-button>
                        <el-button plain v-hasPermi="['questionBank:testPaper:delete']" size="mini" type="danger"
                                   @click="delet(scope.row.id)" :disabled="scope.row.status == 1">
                            {{ buttonTextConfig.remove.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.page_number" :pageSize.sync="form.page_size"
                        :total.sync="total"></pagination>
            <edit-dialog :copyPaperRow="row" :copyPaperShow.sync="editDialogVisible"
                         @copyPaperClose="close"></edit-dialog>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import editDialog from './dialog/edit.vue'
import {judgePermissions} from '@/utils/common.js'

export default {
    components: {
        editDialog, pagination
    },
    data() {
        return {
            paperInfoPermissions: false,
            height: 250,
            loading: true,
            form: {
                name: '',
                status: null,
                page_number: 1,
                page_size: 20
            },
            total: 0,
            statusOptions: [{
                label: this.$store.state.global.textConfig.backend.testPaper.table.use.false,
                value: 0
            }, {
                label: this.$store.state.global.textConfig.backend.testPaper.table.use.true,
                value: 1
            }],
            tableData: [],
            editDialogVisible: false,
            row: null
        }
    },
    computed: {
        testPaperTextConfig() {
            return this.$store.state.global.textConfig.backend.testPaper
        },
        searchTextConfig() {
            return this.testPaperTextConfig.search
        },
        tableTextConfig() {
            return this.testPaperTextConfig.table
        },
        buttonTextConfig() {
            return this.tableTextConfig.button
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === 'testPaperEdit' || from.name === 'testPaperPreview') {
            to.meta.isBack = true
        } else {
            to.meta.isBack = false
        }
        next()
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /*列表重新加载*/
        }
        this.$route.meta.keepAlive = true
    },
    methods: {
        judgePermissions,
        search(val) {
            this.loading = true
            if (val) {
                this.form.page_number = val
            }
            this.$store.dispatch("getPaperList", this.form).then(res => {
                this.loading = false
                this.tableData = res.data.list
                this.total = res.data.total
                this.form.page_number = res.data.pageNumber
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].metas = JSON.parse(this.tableData[i].metas);
                }
            });
        },
        copy(row) {
            this.row = row
            this.editDialogVisible = true
        },
        delet(id) {
            let removeTextConfig = this.buttonTextConfig.remove
            this.$confirm(removeTextConfig.message, removeTextConfig.title, {
                confirmButtonText: removeTextConfig.ok,
                cancelButtonText: removeTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deletePaper", id).then(res => {
                    this.$message({
                        type: 'success',
                        message: removeTextConfig.success
                    });
                    if (this.tableData.length == 1) {
                        let num = this.form.page_number == 1 ? 1 : this.form.page_number - 1
                        this.search(num)
                    } else {
                        this.search()
                    }
                });
            }).catch(() => {
            });
        },
        reset() {
            this.form = {
                name: '',
                status: null,
                page_number: 1,
                page_size: 20
            }
            this.search(1)
        },
        close(data) {
            this.editDialogVisible = data
            this.row = null
        },
        updateHeight() {
            this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
            this.height = this.height < 460 ? 460 : this.height
        }
    },
    watch: {
        tableData() {
            if (!this.tableData.length) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        }
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    created() {
        this.judgePermissions(['questionBank:testPaper:info']).then(res => {
            if (res) {
                this.paperInfoPermissions = true
            }
        })
        this.search(1)
    },
}
</script>

<style scoped>
</style>
